<template>
  <div class="service-register-dialog">
    <custom-dialog :title="title" width="1000px" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <div class="search-hd">
          <el-form :inline="true">
            <el-form-item style="float: right; margin-right: 0">
              <custom-column :code="tableCode" v-model="tableColumn" style="vertical-align: middle"></custom-column>
            </el-form-item>
            <el-form-item style="float: right">
              <switch-button :link="$refs.container"></switch-button>
            </el-form-item>
          </el-form>
        </div>
        <switch-container ref="container" @search="getCardDetailList()" @clear="clearFilter()">
          <el-form :inline="true" label-position="top">
            <el-form-item :label="$t('dms_device_bootCardDetail_dialog.jie_shu_shi_jian')">
              <!-- 已修改时区 -->
              <el-time-picker is-range v-model="formSearch.timer" range-separator="——" start-placeholder="" value-format="yyyy-MM-dd HH:mm:ss" end-placeholder=""></el-time-picker>
            </el-form-item>
          </el-form>
        </switch-container>
        <div class="table-bd" style="height: 500px">
          <custom-table :data="tableColumn.length ? detailList : []" type="index" height="100%" @filter="filterChange" @sort="sortChange" :column="tableColumn"></custom-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDialog">
          {{ $t('Common.com_close') }}
        </el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  components: {},
  computed: {
    title() {
      let info;
      if (this.model.data.bootCardNum || this.model.data.cardColor || this.model.data.user) {
        info = this.$t('dms_device_bootCardDetail_dialog.kjksyxqooo', [this.model.data.bootCardNum,this.getDicValue('dms_boot_card_color', this.model.data.cardColor),this.model.data.user || '']);
      } else {
        info = this.$t('dms_device_bootCardDetail_dialog.kjksyxq');
      }
      return info || this.model.title;
    },
  },
  data() {
    return {
      tableCode: 'sheet_card_details',
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',

        bodyNum: '',
        startTime: '',
        endTime: '',
        bootCardNum: '',
        useType: '', // 模式
        workClass: '', // 模式
        // 筛选
        timer: '',
        searchStartTime: '', // 结束时间
        searchEndTime: '', // 结束时间
      },
      detailList: [],
      timer: [],
      totalRows: 0,
      // 字典值
      invoiceType: [],
    };
  },
  mounted() {
    this.initDialog();
    this.getTableColumn();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });

      this.formSearch.bodyNum = this.model.bodyNum;
      this.formSearch.startTime = this.model.startTime;
      this.formSearch.endTime = this.model.endTime;
      this.formSearch.bootCardNum = this.model.bootCardNum;
      this.formSearch.useType = this.model.data.useType;
      this.formSearch.workClass = this.model.data.workClass;
      // this.timer = [this.formSearch.startTime , this.formSearch.endTime ];

      // this.$set(this.formSearch, 'publishTimer', [
      //   this.form.beginTime,
      //   this.form.endTime
      // ]);
      // 有卡号才去请求
      // if (this.formSearch.bootCardNum) {
      // 获取列表
      this.getCardDetailList();
      // }
    },
    getCardDetailList: function () {
      let tipsDayStartTime;
      let tipsDayEndTime;
      const timer = this.formSearch.timer;
      const YYYYMMDD = moment(this.formSearch.endTime).format('YYYY-MM-DD');
      if (timer && timer[0]) {
        const startTimeStr = this.$momentWorld(`${YYYYMMDD} ${timer[0].split(' ')[1]}`);
        const endTimeStr = this.$momentWorld(`${YYYYMMDD} ${timer[1].split(' ')[1]}`);
        tipsDayStartTime = startTimeStr;
        tipsDayEndTime = endTimeStr;
      }

      const reqData = {
        ...this.formSearch,
        startTime: tipsDayStartTime || this.formSearch.startTime,
        endTime: tipsDayEndTime || this.formSearch.endTime,
        isTimeSearch: tipsDayEndTime ? 1 : 0,
        reportDate: moment(this.formSearch.endTime).format('YYYY-MM-DD')
      };

      this.$getJSON(apis.DeviceReportDailyBootCardWorkRunList, reqData).then((res) => {
        this.detailList = res.data;
      });
    },
    clearFilter: function () {
      this.formSearch.timer = ''; // 发布时间
      this.getCardDetailList();
    },

    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
  },
};
</script>

<style lang="scss">
.service-register-dialog {
  .title {
    color: #000000;
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 15px;
  }
}
</style>
